"use client";

import { ALGOLIA_ANALYTICS_INDEX } from "@raumagarn/algolia";
import { useQuery } from "@tanstack/react-query";
import { tryCatch } from "@trydig/utils";
import { algoliaClient } from "~/features/algolia/client";

interface PopularQuery {
	query: string;
	popularity: number;
	objectID: string;
}

export const useAlgoliaPopularSearches = ({ limit = 10 }) => {
	return useQuery({
		queryKey: ["popular-searches", limit],
		queryFn: async (): Promise<string[]> => {
			const [data, error] = await tryCatch(
				algoliaClient.searchSingleIndex<PopularQuery>({
					indexName: ALGOLIA_ANALYTICS_INDEX,
					searchParams: {
						query: "",
						hitsPerPage: 50,
					},
				}),
			);

			if (error) {
				console.error("Failed to fetch popular searches:", error);
				return [];
			}

			const popularQueries = data.hits
				.filter((query) => query.popularity > 0)
				.sort((a, b) => b.popularity - a.popularity)
				.slice(0, limit)
				.map((query) => query.query);

			return popularQueries;
		},
		staleTime: 5 * 60 * 1000,
		gcTime: 10 * 60 * 1000,
	});
};
